export default {
	pending: 0,
	added: 1,
	approved: 2,
	cancelled: 3
}